import { ApiClient } from '@/services/http/apiClient';
import type {
  ApiResponse,
  Pagination,
  Product as ApiProduct,
  ProductFilters,
  Category as ApiCategory,
} from '@/types/api';

export const ProductService = {
  // Público
  async list(filters?: ProductFilters): Promise<Pagination<ApiProduct>> {
    const response = await ApiClient.get<ApiResponse<Pagination<ApiProduct>>>('/products', { query: filters });
    if (!response.success) {
      throw new Error(response.message || 'Erro ao listar produtos');
    }
    return response.data;
  },

  async getById(id: number): Promise<ApiProduct> {
    const response = await ApiClient.get<ApiResponse<ApiProduct>>(`/products/${id}`);
    if (!response.success) {
      throw new Error(response.message || 'Produto não encontrado');
    }
    return response.data;
  },

  async categories(): Promise<ApiCategory[]> {
    const response = await ApiClient.get<ApiResponse<ApiCategory[]>>('/products/categories/list');
    if (!response.success) {
      throw new Error(response.message || 'Erro ao listar categorias');
    }
    return response.data;
  },

  // Admin
  admin: {
    async create(data: Partial<ApiProduct> & { name: string; price_cents: number }) {
      const response = await ApiClient.post<ApiResponse<ApiProduct>>('/admin/products', { body: data });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao criar produto');
      }
      return response.data;
    },
    async update(id: number, data: Partial<ApiProduct>) {
      const response = await ApiClient.put<ApiResponse<ApiProduct>>(`/admin/products/${id}`, { body: data });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao atualizar produto');
      }
      return response.data;
    },
    async delete(id: number) {
      const response = await ApiClient.delete<ApiResponse<{ success: boolean; message?: string }>>(`/admin/products/${id}`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao remover produto');
      }
      return response.data;
    },
    async toggleActive(id: number) {
      const response = await ApiClient.patch<ApiResponse<ApiProduct>>(`/admin/products/${id}/toggle-active`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao alterar status do produto');
      }
      return response.data;
    },
    async toggleStatus(id: number) { // alias
      const response = await ApiClient.patch<ApiResponse<ApiProduct>>(`/admin/products/${id}/toggle-status`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao alternar status do produto');
      }
      return response.data;
    },
    async updateStock(id: number, stock_quantity: number) {
      const response = await ApiClient.patch<ApiResponse<ApiProduct>>(`/admin/products/${id}/update-stock`, { body: { stock_quantity } });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao atualizar estoque');
      }
      return response.data;
    },
  },
};